// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"aaf18d92","703":"abfd98ff"}[chunkId] + ".chunk.js";
};